'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1024 864l-300.486-300.486c28.384-53.576 44.486-114.66 44.486-179.514 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c64.854 0 125.938-16.102 179.514-44.486l300.486 300.486 160-160zM128 384c0-141.384 114.616-256 256-256s256 114.616 256 256-114.616 256-256 256-256-114.616-256-256z' })
    ));
};